import { render, staticRenderFns } from "./SavedSearchAwardCard.vue?vue&type=template&id=4ab59992&scoped=true"
import script from "./SavedSearchAwardCard.vue?vue&type=script&lang=js"
export * from "./SavedSearchAwardCard.vue?vue&type=script&lang=js"
import style0 from "./SavedSearchAwardCard.vue?vue&type=style&index=0&id=4ab59992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab59992",
  null
  
)

export default component.exports